import React, { FC, useCallback } from "react";
import {
  capitalize,
  ListItemIcon,
  ListItemText,
  MenuItem,
} from "@mui/material";
import { OneTimeReportType } from "../utils/types/types";
import { IntegrationLogo } from "@/components/common/integration-dialogs/components/common/IntegrationLogo";

interface SendReportTypeMenuItemProps {
  onClick(type: OneTimeReportType): void;
  type: OneTimeReportType;
}

export const SendReportTypeMenuItem: FC<SendReportTypeMenuItemProps> = ({
  onClick,
  type,
}) => {
  const clickHandler = useCallback(() => {
    onClick(type);
  }, [onClick, type]);

  return (
    <MenuItem dense onClick={clickHandler}>
      <ListItemIcon>
        <IntegrationLogo type={type} width={20} />
      </ListItemIcon>
      <ListItemText>Send {capitalize(type)}</ListItemText>
    </MenuItem>
  );
};
